module.exports = __webpack_public_path__ + "assets/img/product-head.10344be2.png";